import { z } from 'zod';

/**
 * URL search-parameter schema for the `/templates` route. `templateCollectionId`
 * drives the list/detail split — same shape as `workspaceId` elsewhere, so
 * refresh / deep link / back all work. Split out of `../search-schema.ts` now
 * that Templates is its own top-level route rather than a `/settings` tab.
 */
export const templatesSearchSchema = z.object({
  templateCollectionId: z.coerce.number().int().optional(),
});

export type TemplatesSearch = z.infer<typeof templatesSearchSchema>;
